import * as React from "react";

import { Grid, Typography, makeStyles } from "@material-ui/core";
import Empty from "../../../static/Empty";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    margin: "10px auto",
    padding: "20px 10px",
    border: "solid 1px #B6B3B3",
  },
  p: {
    padding: 10,
  },
  t1: {
    color: "#0A369D",
    fontWeight: "bold",
    fontSize: 18,
  },
  t2: {
    color: "#292929",
    fontSize: 16,
    fontFamily: "Vazir",
    marginTop: 5,
    lineHeight: 1.7,
    marginBottom: 50,
  },
}));

const Vision = ({ data }) => {
  const classes = useStyles();

  if (data && (data.vision || data.mission)) {
    return (
      <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.p}>
          <Typography variant="h2" className={classes.t1}>
            چشم انداز
          </Typography>
          <p className={classes.t2}>
            {data.vision || "اطلاعات مربوطه توسط موسسه تکمیل نشده است"}
          </p>
          <Typography variant="h2" className={classes.t1}>
            ماموریت
          </Typography>
          <p className={classes.t2}>
            {data.mission || "اطلاعات مربوطه توسط موسسه تکمیل نشده است"}
          </p>
        </Grid>
      </Grid>
    );
  }
  return <Empty />;
};

export default Vision;
